import React, {useEffect} from 'react';
import {RouterState} from '@store/@types/util/ReactRouter';
import {renderMicroFrontend, unmountMicroFrontend} from 'utils/microfrontends/setup';
import {browserHistory} from 'react-router';

interface CoachHomepageProps extends RouterState {}

export const CoachHomepage: React.FC<CoachHomepageProps> = props => {
  useEffect(() => {
    renderMicroFrontend('homepage', {
      parentNavigator: (path: string) => browserHistory.replace(path),
    }).catch(e => {
      console.error('Error loading homepage MFE', e);
      browserHistory.replace('/');
    });
    return () => {
      unmountMicroFrontend('homepage').catch(console.error);
    };
  });

  return (
    <div id="homepage-container" style={{height: '100%', width: '100%'}}>
      Loading homepage...
    </div>
  );
};
